// import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

class AuthService {
    requestOTP(login_form){
        return login_form.post(`${API_URL}/users/otp`);
    }

    login(login_form){
        return login_form.post(`${API_URL}/users`);
    }
}

export default new AuthService();
